export default {
  namespaced: true,
  state: {
    valid: false,
    validEdit: true
  },

  actions: {
    getItem(context, payload) {
      context.commit('setIsFetching', true);
      return axios
        .get(`${APIURL}trackinglocations/${payload._id}`)
        .then(res => {
          context.commit('setIsFetching', false);
          return res.data;
        })
        .catch(err => {
          context.commit('setIsFetching', false);
          return Promise.reject(err);
        });
    },

    updateLatLng(context, payload) {
      const url = `${APIURL}trackinglocations/${payload.id}/latlng`;

      return axios.patch(url, payload);
    },

    checkIfAnswerExists(context, payload) {
      let name = payload[0].name;
      let valid = false;
      //console.log("##### name", name)
      let editableTask = context.rootGetters['checkpoints/editableTask'];
      let answers = editableTask.question.answers;
      let duplicate = Object.keys(answers).find(a => {
        return !answers[a].isBeingReplaced && a === name;
      });

      if (!duplicate) {
        valid = true;
      }

      return Promise.resolve(valid);
    },

    validateSeasonVideoTaskEdit(context) {
      let valid = false;
      let editableTask = context.rootGetters['checkpoints/editableTask'];
      let files = editableTask.question.files;
      let seasons = context.rootGetters['checkpoints/seasons'];

      if (typeof files !== 'undefined') {
        files = Object.keys(files).filter(f => {
          return files[f].delete !== true;
        });

        if (
          Object.keys(files).length >= 2 &&
          Object.keys(files).length <= seasons.length
        ) {
          valid = true;
        }
      }

      return Promise.resolve(valid);
    },

    validateSeasonVideoTask(context) {
      let valid = false;
      let newTask = context.rootGetters['checkpoints/newTask'];
      let answers = newTask.answers;
      let seasons = context.rootGetters['checkpoints/seasons'];
      if (typeof answers !== 'undefined') {
        let keys = Object.keys(answers);
        if (keys.length >= 2 && keys.length <= seasons.length) {
          let validAnswers = keys.filter(k => {
            return typeof answers[k].error === 'undefined';
          });

          if (validAnswers.length === keys.length) {
            valid = true;
          }
        }
      }

      return Promise.resolve(valid);
    },

    validateImageTaskEdit(context) {
      let valid = false;
      let task = context.rootGetters['checkpoints/editableTask'];
      if (
        task.question.content.trim() !== '' &&
        task.question.description.trim() !== '' &&
        typeof task.question.answers !== 'undefined' &&
        Object.keys(task.question.answers).length === 2
      ) {
        valid = true;
      }
      // check answers
      if (valid) {
        let isEmpty = Object.keys(task.question.answers).find(i => {
          return task.question.answers[i].content.trim() === '';
        });

        if (isEmpty) {
          valid = false;
        }
      }
      return Promise.resolve(valid);
    },

    validateImageTask(context) {
      let valid = false;
      let task = context.rootGetters['checkpoints/newTask'];
      if (
        task.question.content.trim() !== '' &&
        task.question.description.trim() !== '' &&
        typeof task.answers !== 'undefined' &&
        Object.keys(task.answers).length == 2
      ) {
        valid = true;
      }
      // check answers
      if (valid) {
        let isEmpty = Object.keys(task.answers).find(i => {
          return task.answers[i].trim() === '';
        });

        if (isEmpty) {
          valid = false;
        }
      }

      return Promise.resolve(valid);
    },

    validateTextTaskEdit(context) {
      let valid = false;
      let task = context.rootGetters['checkpoints/editableTask'];

      if (
        task.question.description.trim() !== '' &&
        task.question.content.trim() !== ''
      ) {
        valid = true;
      }

      //console.log("valid", valid)

      return Promise.resolve(valid);
    },

    validateTextTask(context) {
      let valid = false;
      let task = context.rootGetters['checkpoints/newTask'];

      if (
        task.question.description.trim() !== '' &&
        task.question.content.trim() !== ''
      ) {
        valid = true;
      }

      return Promise.resolve(valid);
    },

    validateSingleImageTask(context) {
      let valid;
      let files = context.rootGetters['files/filesToUpload'];
      //console.log("########## validateSingleImageTask", files)

      if (
        typeof files !== 'undefined' &&
        files.length === 1 &&
        typeof files[0].error === 'undefined'
      ) {
        //console.log("should be valid")
        valid = true;
      }

      return Promise.resolve(valid);
    },

    validateYoutubeVideoTask(context, payload) {
      let valid = false;
      let video = payload;
      let url = undefined;
      if (typeof video !== 'undefined' && video.trim() !== '') {
        switch (true) {
          //case /^#\/$/.test(video):
          //case /^\S+youtube.com\/watch\?v=\S+$/.test(video):
          case /^https:\/\/www\.youtube.com\/watch\?v=\S+$/.test(video):
            valid = true;
            let parts = video.split('?v=');
            if (parts.length == 2) {
              url = parts[1];
            }
            break;

          case /^https:\/\/youtu.be\/[^\s\/]+$/.test(video):
            valid = true;
            let lio = video.lastIndexOf('/') + 1;
            url = video.substring(lio);

          default:
            console.error('not a valid link');
        }
      }

      return Promise.resolve({ valid: valid, url: url });
    },

    validateFeedbackTask(context) {
      let valid = false;
      let task = context.rootGetters['checkpoints/newTask'];

      if (task.question.description.trim() !== '') {
        valid = true;
      }

      return Promise.resolve(valid);
    },

    validateFeedbackTaskEdit(context) {
      let valid = false;
      let task = context.rootGetters['checkpoints/editableTask'];

      if (task.question.description.trim() !== '') {
        valid = true;
      }

      return Promise.resolve(valid);
    },

    validateCameraTaskEdit(context) {
      let valid = false;
      let editableTask = context.rootGetters['checkpoints/editableTask'];
      let answers = editableTask.question.answers;
      if (Object.keys(answers).length >= 1) {
        let isEmpty = Object.keys(answers).find(a => {
          typeof answers[a].content === 'undefined' ||
            answers[a].content.trim() === '';
        });

        if (!isEmpty) {
          valid = true;
        }
      }

      return Promise.resolve(valid);
    },

    validateCameraTask(context) {
      let valid = false;
      let task = context.rootGetters['checkpoints/newTask'];
      let files = context.rootGetters['files/filesToUpload'];
      if (files.length >= 1) {
        valid = true;
      }

      if (valid) {
        if (typeof task.answers === 'undefined') {
          valid = false;
        } else {
          let isEmpty = Object.keys(task.answers).find(i => {
            return task.answers[i].trim() === '';
          });

          if (isEmpty) {
            valid = false;
          }
        }
      }
      return Promise.resolve(valid);
    },

    validateAudioTask(context) {
      let valid = false;
      let task = context.rootGetters['checkpoints/newTask'];
      if (
        task.question.content.trim() !== '' &&
        task.question.description.trim() !== '' &&
        typeof task.answers !== 'undefined' &&
        Object.keys(task.answers).length === 2
      ) {
        valid = true;
      }
      // check answers
      if (valid) {
        let isEmpty = Object.keys(task.answers).find(i => {
          return task.answers[i].trim() === '';
        });

        if (isEmpty) {
          valid = false;
        }

        let filesToUpload = context.rootGetters['files/filesToUpload'];

        let matchingImageMissing = filesToUpload.find(f => {
          return typeof f.matchingImage === 'undefined';
        });

        if (matchingImageMissing) {
          valid = false;
        }
      }
      return Promise.resolve(valid);
    },

    validateAudioTaskEdit(context) {
      let valid = false;
      let task = context.rootGetters['checkpoints/editableTask'];
      if (
        task.question.content.trim() !== '' &&
        task.question.description.trim() !== '' &&
        typeof task.question.answers !== 'undefined' &&
        Object.keys(task.question.answers).length == 2
      ) {
        valid = true;
      }
      // check answers
      if (valid) {
        let isEmpty = Object.keys(task.question.answers).find(i => {
          return task.question.answers[i].content.trim() === '';
        });

        if (isEmpty) {
          valid = false;
        }
      }
      //console.log("###################### validateAudioTaskEdit", valid)
      return Promise.resolve(valid);
    },

    validateVideoTaskEdit(context) {
      let valid = false;
      let t = context.rootGetters['checkpoints/editableTask'];
      if (typeof t !== 'undefined') {
        if (t.question.files.length === 1) {
          valid = true;
        }
      }

      return Promise.resolve(valid);
    },

    validateVideoTask(context) {
      let valid = false;
      let files = context.rootGetters['files/filesToUpload'];
      if (files.length == 1) {
        valid = true;
      }

      return Promise.resolve(valid);
    }
  },

  mutations: {
    setValid(state, payload) {
      state.valid = payload;
    },

    setValidEdit(state, payload) {
      state.validEdit = payload;
    }
  },

  getters: {
    isValidEdit(state) {
      return state.validEdit;
    },

    isValid(state) {
      //console.log("isValid", state.valid)
      return state.valid;
    }
  }
};
